import { render, staticRenderFns } from "./view-transport.vue?vue&type=template&id=b73db46c&"
import script from "./view-transport.vue?vue&type=script&lang=ts&"
export * from "./view-transport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports